import React from "react";
import { PaginationType } from "@/DTO";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "@/redux-config/hooks";
import { selectLanguage } from "@/redux-config/entities/language";
import { ConvertNumber } from "@/utils";

export const PaginationText: React.FC<{ pagination: PaginationType }> = ({
                                                                           pagination
                                                                         }) => {
  const { t } = useTranslation();
  const lang = useAppSelector(selectLanguage);

  return (
    <small>
      {t("Showing")} {ConvertNumber((pagination.currentPage - 1) * 10 + 1 + "", lang)} {t("to")}{" "}
      {pagination.currentPage * 10 <=
      (pagination?.total ? pagination?.total : 0)
        ? ConvertNumber(pagination.currentPage * 10 + "", lang)
        : ConvertNumber(pagination.total + "", lang)}{" "}
      {t("of")} {ConvertNumber(pagination.total + "", lang)} {t("entries")}
    </small>
  );
};
